var React = require('react');

function Support (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Support"),React.createElement("g",{"id":"Support","key":1},React.createElement("path",{"d":"M39,22V20A15,15,0,0,0,9,20v2a3,3,0,0,0-3,3v6a3,3,0,0,0,3,3h1a2,2,0,0,0,4,0V22a2,2,0,0,0-3-1.72V20a13,13,0,0,1,26,0v.28A2,2,0,0,0,34,22V34a2,2,0,0,0,2,2,1.85,1.85,0,0,0,.74-.15A7,7,0,0,1,30,41H27V40a3,3,0,1,0-3,3h6a9,9,0,0,0,9-9,3,3,0,0,0,3-3V25A3,3,0,0,0,39,22Z"}))]);
}

Support.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Support;

Support.default = Support;
